import { render, staticRenderFns } from "./RealmGuideStep.vue?vue&type=template&id=4ec286c9&scoped=true&"
import script from "./RealmGuideStep.vue?vue&type=script&lang=js&"
export * from "./RealmGuideStep.vue?vue&type=script&lang=js&"
import style0 from "./RealmGuideStep.vue?vue&type=style&index=0&id=4ec286c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec286c9",
  null
  
)

export default component.exports